// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thankyou-page h1 {
  margin: 20px 0; }

.thankyou-page a {
  color: #4330ff; }
`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/Thankyou/thankyou.css"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE","sourcesContent":[".thankyou-page h1 {\n  margin: 20px 0; }\n\n.thankyou-page a {\n  color: #4330ff; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
